module.exports = __webpack_public_path__ + "img/client_side.5be7204c.png";